import { Controller } from "@hotwired/stimulus"

/**
 * URL Param Controller
 * 
 * Updates URL query parameters based on input value on blur or Enter key press.
 * 
 * Usage:
 *   <input type='text' 
 *     name='search'
 *     data-controller="url-param"
 *     data-url-param-url-value="/search"
 *     data-action="blur->url-param#update keydown->url-param#onKeydown"
 *   />
 * 
 * Values:
 *   - url: The base URL to navigate to with the input value as a query parameter
 */
export default class extends Controller {
  static values = { url: String }

  update() {
    if (!this.hasUrlValue || !this.urlValue) return

    const url = new URL(this.urlValue, window.location.origin)
    const paramName = this.element.name
    const value = this.element.value.trim()

    if (value) {
      url.searchParams.set(paramName, value)
    } else {
      url.searchParams.delete(paramName)
    }

    window.location.href = url.toString()
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.update()
    }
  }
}
